const DEFAULT_PAGE = 1;
const DEFAULT_PAGE_SIZE = 999;

export class TiktokService {
    constructor(context) {
      this.context = context;
      this.axios = this.context.$axios;
    }

    async GetTiktokCampaigns({
        advertiser_id,
        start_date,
        end_date,
    }) {
      try {
        const tiktokCampaigns = await this.axios.get(
          `${process.env.VUE_APP_API_BASE_URL}/tiktok?metrics=clicks,impressions,ctr,conversion,frequency,video_views_p100,reach,comments,likes,shares,campaign_name&dimensions=campaign_id&advertiser_id=${advertiser_id}&order_field=impressions&order_type=DESC&data_level=AUCTION_CAMPAIGN&report_type=BASIC&page_size=${DEFAULT_PAGE_SIZE}&page=${DEFAULT_PAGE}&start_date=${start_date}&end_date=${end_date}`
        );
        return tiktokCampaigns.data;
      } catch (err) {
        console.log(err);
      }
    }

}